import { render, staticRenderFns } from "./AdminReport.vue?vue&type=template&id=4a8d579f&"
import script from "./AdminReport.vue?vue&type=script&lang=js&"
export * from "./AdminReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports